import { EnvCms } from '@bcf-vanilla-ts-v1-api-access/config-tokens/env-cms';
import { EnvCp } from '@bcf-vanilla-ts-v1-api-access/config-tokens/env-cp';
import { EnvFe } from '@bcf-vanilla-ts-v1-api-access/config-tokens/env-fe';
import { EnvCommon } from '@bcflit-env/types';
import { envBaseCommon } from './env.base';

export const envCp: EnvCp = {
  userApiUrl: 'https://user.tikalcasino{apiVersion}.com/',
  walletApiUrl: 'https://wallet.tikalcasino{apiVersion}.com/',
  paymentApiUrl: 'https://payment.tikalcasino{apiVersion}.com/',
  cpSocketUrl1: 'wss://ws.tikalcasino{apiVersion}.com/register'
};

export const envCms: EnvCms = {
  cmsApiUrl: 'https://cms.tikalcasino{apiVersion}.com/'
};

export const envFe: EnvFe = {
  feApiUrl: 'https://tikalcasino{apiVersion}.com'
};

// // eslint-disable-next-line @typescript-eslint/typedef
export const envCommon: EnvCommon = {
  ...envBaseCommon
};
